<template>
  <div class="container" v-show="user.avatar">
    <div class="nav" :class="showNav ? 'showNav' : ''">
      <div class="goBack" @click="goBack()">
        <van-icon name="arrow-left" size="18px" color="#fff"/>
      </div>
      <div class="bg" @click="ClickBox()">
        <!-- <span>封面</span> -->
        <van-icon name="photo-o" size="26px" color="#fff"/>
        <input ref="update" @click="updateClick" class="update-input" type="file" accept="image/*" name="file" @change="update">
      </div>
    </div>
    <div @click="showImg()" class="user" :class="showAll ? 'showAll' : (first ? '' : 'close')" :style="user.bgImg ? `background-image: url(${user.bgImg})` : ''">
      <div class="info">
        <span>{{user.name}}</span>
        <img :src="user.avatar" alt="">
      </div>
    </div>
    <div class="upload" @click="go('ywq-add')">
      <span>今天</span>
      <div class="box">
        <van-icon name="photograph" size="38px" color="#dcdee0"/>
      </div>
    </div>
    <!-- <van-pull-refresh v-model="refreshing" @refresh="getList(1)" style="min-height: calc(100vh - 300px) !important;"> -->
      <section class="flex all-c" style="height: calc(100vh - 300px);" v-if="list && list.length === 0">
        <div class="txt-c">
          <div class="img-auto"><img src="../../assets/images/blank.png" style="width:71px;"/></div>
          <p class="f18 c-999 mt15">暂无内容</p>
        </div>
      </section>
      <template v-if="list && list.length">
        <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="getList(0)">
          <div v-for="(it, index) in list" :key="index" class="list">
            <span class="year">{{it.year}}年</span>
            <div class="item" v-for="(item, id) in it.list" :key="id" @click="go('ywq-detail?id=' + item.data_encrypt)">
              <p class="date">
                <span class="day">{{item.day}}</span>
                <span class="month">{{item.month}}月</span>
              </p>
              <div class="detail">
                <div class="img-box" v-if="item.files" :class="`list-${item.files.length}`">
                  <div class="img-item" v-for="(img, i) in item.files" :key="i">
                    <img :src="img" alt="">
                  </div>
                </div>
                <p class="txt-elips3l">{{item.content}}</p>
              </div>
            </div>
          </div>
        </van-list>
      </template>
    <!-- </van-pull-refresh> -->
  </div>
</template>
<script>
import { uploadFile2 } from '@/api/retry';
import Compressor from 'compressorjs';
export default {
  name: 'ywq',
  components: {},
  data() {
    return {
      user: {
        name: '',
        avatar: require('@/assets/images/avatar.png'),
        bgImg: require('@/assets/images/back.jpg')
      },
      first: true,
      showAll: false,
      showNav: false,
      refreshing: false,
      loading: false,
      finished: false,
      nextQuery: '',
      list: []
    };
  },
  computed: {
    // todo
  },
  beforeMount() {
    this.getInfo();
    this.getList(1);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  mounted() {
    // todo
  },
  activated() {
    const obj = window.upDateDetail;
    if (obj && obj.type === 'delect') {
      // eslint-disable-next-line
      let findYear = -1;
      this.list.map((year, id) => {
        const index = year.list.findIndex(i => obj.id === i.data_encrypt);
        if (index > -1) {
          year.list.splice(index, 1);
        }
        if (!year.list.length) {
          findYear = id;
        }
      });
      if (findYear > -1) {
        this.list.splice(findYear, 1);
      }
    }
    if (obj && obj.type === 'add') {
      this.getList(1);
    }
    window.upDateDetail = '';
    window.addEventListener('scroll', this.scroll);
  },
  deactivated() {
    window.removeEventListener('scroll', this.scroll);
  },
  watch: {},
  methods: {
    showImg() {
      this.first = false;
      this.showAll = !this.showAll;
    },
    scroll() {
      setTimeout(() => {
        this.showAll = false;
      }, 300);
      var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollHeight > 170) {
        this.showNav = true;
      } else {
        this.showNav = false;
      }
    },
    goBack() {
      // eslint-disable-next-line
      uni.webView.postMessage({
        data: {
          action: 'Close'
        }
      });
    },
    ClickBox() {
      this.$refs.update.click();
    },
    updateClick(event) {
      if (this.loading) {
        event.preventDefault();
      }
    },
    async update(event) {
      try {
        const files = event.target.files;
        if (files && files.length) {
          const file = files[0];
          const name = file.name;
          if (name.length > 200) {
            this.ToastUni('文件名不得超过200字符！');
            return;
          }
          // const fileType = file.type;
          const maxSize = 5242880; // 最大文件大小限制为5MB（5 * 1024 * 1024字节）
          const CompressorFile = await new Promise((resolve, reject) => {
            // compressorjs 默认开启 checkOrientation 选项
            // 会将图片修正为正确方向
            // eslint-disable-next-line
            new Compressor(file, {
              checkOrientation: !(file.size > maxSize), // 处理 >10MB 图片时禁用 checkOrientation 防止内存溢出
              quality: 0.8, // 压缩质量（0–1）
              maxWidth: 1200, // 最大宽度
              success: newFile => {
                const fileSize = newFile.size; // 获取文件大小（字节）
                if (fileSize > maxSize) {
                  this.ToastUni('文件压缩后大小不能超过5MB！');
                  reject(new Error('文件压缩后大小不能超过5MB！'));
                } else {
                  resolve(newFile);
                }
              },
              error: err => {
                this.$toast.clear();
                reject(err);
              }
            });
          });
          const formData = new FormData();
          formData.append('file', CompressorFile);
          this.Loading(`正在上传...`);
          const res = await uploadFile2(formData, '/api/gate/v1/user/bg-img');
          const data = res.data;
          this.user.bgImg = data.bg_img;
          this.updateUserInfo({
            bgImg: data.bg_img
          });
          this.ToastClear();
        }
      } catch (error) {
        this.ToastClear();
        this.ToastUni('上传失败:' + error.message);
      }
    },
    async getInfo() {
      try {
        const res = await this.getUserInfo({
          success: 'setUser',
          error: 'userError'
        });
        this.user = {
          name: res.name,
          avatar: res.avatar ? res.avatar : this.user.avatar,
          bgImg: res.bgImg || res.bg_path || this.user.bgImg
        };
      } catch (error) {
        this.ToastUni(error.message || error);
      }
    },
    async getList(isPulldown = 0) {
      try {
        if (this.finished && !isPulldown) {
          this.refreshing = false;
          return;
        }
        if (isPulldown) {
          this.refreshing = false;
          this.nextQuery = '';
          this.list = [];
        }
        this.finished = false;
        let url = '';
        if (this.nextQuery) {
          // eslint-disable-next-line
          url = `?data_encrypt=${this.nextQuery}`;
        }
        this.Loading();
        const res = await this.$store.dispatch('getData', {
          url: '/api/http/feed/list' + url
        });
        this.ToastClear();
        this.loading = false;
        const list = res.detail || [];
        list.map(item => {
          const date = item.date.split('-');
          item.year = date[0];
          item.month = date[1];
          item.day = date[2];
          const obj = this.list.find(it => it.year === date[0]);
          if (obj) {
            obj.list.push(item);
          } else {
            this.list.push({
              year: date[0],
              list: [item]
            });
          }
        });
        this.nextQuery = list.length ? list[list.length - 1].data_encrypt : '';
        if (!res.next) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      } catch (e) {
        this.ToastClear();
        this.refreshing = false;
        this.loading = false;
        this.ToastUni(e.message);
      }
    }
  }
};
</script>
<style lang='less' scoped>
.showNav{
  background-color: #d2d6d5;
}
.nav{
  position: sticky;
  top: 0px;
  height: 50px;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  .goBack{
    padding: 10px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bg{
    span{
      width: 50px;
      color: #fff;
      font-size: 12px;
    }
    .van-icon {
      font-weight: bold;
    }
    padding: 10px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.update-input{
  display: none;
}
.user.close{
  animation: close 0.8s forwards;
}
@keyframes close {
  0% {
    height: 500px;
  }
  100% {
    height: 220px;
  }
}
.user.showAll{
  height: 500px;
  background-size: contain;
}
.user.showAll::after{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #99999970 20%, rgba(255,255,255, 0), #99999970 80%);
  z-index: 1; /* 确保蒙层在内容之上 */
}
.user{
  position: relative;
  top: -50px;
  // top: 0px;
  width: 100%;
  height: 220px;
  // height: 155px;
  margin-bottom: -25px;
  // margin-bottom: 20px;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #d2d6d5;
  .info{
    z-index: 2;
    position: absolute;
    bottom: -20px;
    right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    img{
      background-color: #fff;
      border-radius: 50%;
      width: 70px;
      height: 70px;
    }
    span{
      font-size: 20px;
      color: #fff;
      padding: 5px;
    }
  }
}
.upload{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  span{
    width: 80px;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 600;
    padding: 4px 20px;
  }
  .box{
    height: 80px;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f7f8fa;
  }
}
.list{
  padding-bottom: 20px;
  .year{
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 600;
    padding: 4px 20px;
  }
  .item{
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    padding: 10px 0;
    .date{
      padding-left: 20px;
      width: 80px;
      line-height: 20px;
      box-sizing: border-box;
      .day{
        font-size: 18px;
        font-weight: 600;
        margin-right: 2px;
      }
      .month{
        font-size: 12px;
        font-weight: 600;
      }
    }
    .detail{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .img-box{
        width: 80px;
        height: 80px;
        display: grid;
        column-gap: 1px;
        row-gap: 1px;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .list-1{
        grid-template-columns: 1fr;
        grid-auto-rows: 80px;
      }
      .list-2{
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: 80px;
      }
      .list-3,.list-4{
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: (79px / 2);
      }
      .list-3{
        .img-item:nth-child(1){
          grid-row-start: 1;
          grid-row-end: 3;
        }
      }
      .list-5,.list-6,.list-7,.list-8,.list-9{
        grid-template-columns: 1fr 1fr 1fr;
      }
      .list-5{
        .img-item:nth-child(1){
          grid-column-start: 1;
          grid-column-end: 3;
          grid-row-start: 1;
          grid-row-end: 3;
        }
        .img-item:nth-child(2){
          grid-column-start: 3;
          grid-column-end: 4;
          grid-row-start: 1;
          grid-row-end: 3;
        }
      }
      .list-5,.list-7,.list-8,.list-9{
        grid-auto-rows: (78px / 3);
      }
      .list-6{
        grid-auto-rows: (79px / 2);
      }
      p{
        margin: 5px;
        width: calc(100vw - 180px);
        font-size: 14px;
        line-height: 23px;
        height: 69px;
      }
    }
  }
}
</style>
